import { createContext, useContext } from "react";

import type { TestEmailInput } from "@/lib/gql/__generated__/graphql";

import type { AccommodationHotelPolicyFormModel, QueryData } from "../../model/type";

export type AccommodationHotelPolicyFormModelContextType = {
	viewModel: AccommodationHotelPolicyFormModel["ViewModel"];
	onSetViewModel: <K extends keyof AccommodationHotelPolicyFormModel["ViewModel"]>(
		values: { key: K; value: AccommodationHotelPolicyFormModel["ViewModel"][K] }[],
	) => void;
	queryData: QueryData;

	onUpdate: () => Promise<void>;

	hotelID: string;

	testEmailSender: {
		onSendTestEmailReservationCin: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailReservationCanceled: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailReservationCreated: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailReservationUpdated: (input: TestEmailInput) => Promise<void>;

		onSendTestEmailRequestReservationConfirmed: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailRequestReservationDeclined: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailRequestReservationRequested: (input: TestEmailInput) => Promise<void>;
	};
};

export const AccommodationHotelPolicyFormModelContext =
	createContext<AccommodationHotelPolicyFormModelContextType | null>(null);

export const useAccommodationHotelPolicyFormModelContext = (): AccommodationHotelPolicyFormModelContextType => {
	const hotelPolicyStore = useContext(AccommodationHotelPolicyFormModelContext);

	if (!hotelPolicyStore) {
		throw new Error("hotelPolicyStore is null");
	}

	return hotelPolicyStore;
};
